import { Collapsible as BaseCollapsible } from '@base-ui/react/collapsible';
import clsx from 'clsx';
import { LuChevronDown, LuChevronRight } from 'react-icons/lu';

export type CollapsibleProps = BaseCollapsible.Root.Props;
export type CollapsibleTriggerProps = BaseCollapsible.Trigger.Props;
export type CollapsiblePanelProps = BaseCollapsible.Panel.Props;
export type CollapsibleChevronProps = React.ComponentProps<typeof LuChevronDown> & {
  direction?: 'down' | 'right';
};

export const Collapsible = BaseCollapsible.Root;

export function CollapsibleTrigger({ className, ...props }: CollapsibleTriggerProps) {
  return (
    <BaseCollapsible.Trigger
      {...props}
      className={state =>
        clsx(
          'group/collapsible-trigger',
          typeof className === 'function' ? className(state) : className
        )
      }
    />
  );
}

export function CollapsibleChevron({
  className,
  direction = 'down',
  ...props
}: CollapsibleChevronProps) {
  const Icon = direction === 'right' ? LuChevronRight : LuChevronDown;

  return (
    <Icon
      {...props}
      aria-hidden
      focusable="false"
      className={clsx(
        'text-black/40, shrink-0 transition-transform duration-200 ease-in-out motion-reduce:transition-none',
        direction === 'right'
          ? 'group-data-panel-open/collapsible-trigger:rotate-90'
          : 'group-data-panel-open/collapsible-trigger:-rotate-180',
        className
      )}
    />
  );
}

export function CollapsiblePanel({ className, ...props }: CollapsiblePanelProps) {
  return (
    <BaseCollapsible.Panel
      {...props}
      className={state =>
        clsx(
          "h-(--collapsible-panel-height) overflow-hidden transition-[height] duration-200 ease-in-out data-ending-style:h-0 data-starting-style:h-0 motion-reduce:transition-none [&[hidden]:not([hidden='until-found'])]:hidden",
          typeof className === 'function' ? className(state) : className
        )
      }
    />
  );
}
